"use strict"

angular.module("customer")
.service("UnauthenticatedInvoiceService", function($resource, FlashBag, appConfig) {
    var resource = $resource(appConfig.API_SERVER + "/invoice/copy/:uuid/", {uuid: "@uuid"}, {
        get: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    var pdfResource = $resource(appConfig.API_SERVER + "/invoice/copy/pdf/:uuid/:pdfFormat/:outputType/", {uuid: "@uuid", pdfFormat: "@pdfFormat", outputType: "@outputType"}, {
        create: {
            method: "POST",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    this.query = function(params) {
        return resource.query(params);
    };

    this.get = function(uuid) {
        var params = {
            uuid: uuid
        };
        return resource.get(params);
    };

    this.downloadPDF = function(uuid, pdfFormat) {
        return pdfResource.save(
            {
                uuid: uuid,
                pdfFormat: pdfFormat,
                outputType: "print"
            }
        )
    }

    this.emailPDF = function(uuid, pdfFormat, recipient) {
        return pdfResource.save(
            {
                uuid: uuid,
                email: recipient,
                pdfFormat: pdfFormat,
                outputType: "email"
            }
        )
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/invoice-copy/unauthenticated-invoice.service.js
// module id = 918
// module chunks = 0